<template>
	<div>
		<v-card-title>
			<h2>Lista projektów z udziałem wolontariusza {{volunteerName}}</h2>
		</v-card-title>
		<ProjectTable
			:volunteer="true"/>
	</div>
</template>

<script>

	import ProjectTable from "./components/ProjectTable";
	import {Volunteer} from "@/api/generated/Volunteer";

	export default {
		name: "VolunteerProjectsList",
		components: {
			ProjectTable,

		},

		data () {
			return {
				volunteerName: "",
			};
		},

		mounted () {
			loadName(this);
		},
	};

	function loadName (ctx) {
		Volunteer.getName(ctx, ctx.$route.params.volunteerId, response => {
			ctx.volunteerName = response.name + " " + response.surname;
		});
	}
</script>

<style scoped>

</style>